(()=>{
const totalKey='🎟️ TOTAL ENTRIES';
const entryKey='_wm_entries_per_item',bonusKey='Quick checkout bonus',bonus='+100 entries per order, once; pay within 2 minutes';
const root=()=>window.Shopify?.routes?.root||'/';
const count=(price,multiplier,fixed)=>fixed!==null&&fixed!==undefined&&fixed!==''?Number(fixed):Math.floor(Number(price)/100)*Number(multiplier);
const format=n=>Math.max(0,Math.floor(n)).toLocaleString('en-US');
function update(form){
 const input=form.querySelector('[data-wm-checkout-entries]'),json=form.querySelector('[data-wm-entry-variants]');
 if(!input||!json)return;
 const prices=JSON.parse(json.textContent),variant=form.querySelector('[name="id"]');
 const n=count(prices[variant?.value],input.dataset.wmEntryMultiplier,input.dataset.wmFixedEntries);
 if(Number.isFinite(n)){
  input.value=format(n);
  const totalInput=form.querySelector('[data-wm-checkout-total]');
  const quantity=Math.max(1,Math.floor(Number(form.querySelector('[name="quantity"]')?.value)||1));
  if(totalInput)totalInput.value=format(n*quantity+100);
 }
}
function init(){
 document.querySelectorAll('form').forEach(form=>{if(!form.querySelector('[data-wm-checkout-entries]'))return;update(form);form.addEventListener('change',()=>update(form));form.addEventListener('submit',()=>update(form));});
}
async function syncCart(){
 const response=await fetch(root()+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
 if(!response.ok)throw new Error('Unable to confirm checkout entries. Please try again.');
 const cart=await response.json();
 const rulesResponse=await fetch(root()+'?sections=wm-checkout-entry-data',{cache:'no-store',headers:{Accept:'application/json'}});
 if(!rulesResponse.ok)throw new Error('Unable to confirm checkout entries. Please try again.');
 const sections=await rulesResponse.json(),doc=new DOMParser().parseFromString(sections['wm-checkout-entry-data']||'','text/html');
 const node=doc.querySelector('[data-wm-cart-entry-rules]');
 if(!node)throw new Error('Unable to confirm checkout entries. Please try again.');
 const rules=JSON.parse(node.textContent);
 const total=cart.items.reduce((sum,item)=>{
  const rule=rules[String(item.variant_id)];
  if(!rule)throw new Error('Unable to confirm an item’s entry count.');
  const n=count(rule.price,rule.multiplier,rule.fixed);
  if(!Number.isFinite(n))throw new Error('Unable to confirm an item’s entry count.');
  return sum+n*item.quantity;
 },0)+100;
 for(let i=0;i<cart.items.length;i++){
  const item=cart.items[i],rule=rules[String(item.variant_id)];
  if(!rule)throw new Error('Unable to confirm an item’s entry count.');
  const n=count(rule.price,rule.multiplier,rule.fixed);
  if(!Number.isFinite(n))throw new Error('Unable to confirm an item’s entry count.');
  const existing={...item.properties};
  delete existing[totalKey];
  delete existing['TOTAL GIVEAWAY ENTRIES'];
  delete existing['Giveaway entries per item'];
  const properties=i===0?{[totalKey]:format(total),...existing,[entryKey]:format(n)}:{...existing,[entryKey]:format(n)};
  if(i===0){
   const deadline=Date.parse(cart.attributes?.['WM Quick Bonus Deadline UTC']||'');
   properties[bonusKey]=Number.isFinite(deadline)?'+100 entries per order, once; pay by '+new Date(deadline).toLocaleString('en-US',{timeZone:'America/New_York',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',second:'2-digit'})+' ET':bonus;
  }else delete properties[bonusKey];
  if(JSON.stringify(properties)===JSON.stringify(item.properties||{}))continue;
  const changed=await fetch(root()+'cart/change.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties})});
  if(!changed.ok)throw new Error('Unable to attach checkout entries. Please try again.');
 }
}
window.WMCheckoutEntries={syncCart};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();